/**
 * Recent items tracking constants and types
 */

export const RECENT_ITEMS_STORAGE_KEY = 'recent-items-history'

export const RecentItemsCategory = {
    APPS: 'apps',
    GROUPS: 'groups',
} as const

export type RecentItemsCategory = typeof RecentItemsCategory[keyof typeof RecentItemsCategory]

export type RecentItemEntry = {
    id: string
    lastVisited: number
    isPinned: boolean
}

export type RecentItemsStore = {
    [category: string]: Record<string, RecentItemEntry>
}
